import { render, staticRenderFns } from "./MobileApprovalComplete.vue?vue&type=template&id=6a2c84c8&scoped=true&"
import script from "./MobileApprovalComplete.vue?vue&type=script&lang=js&"
export * from "./MobileApprovalComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2c84c8",
  null
  
)

export default component.exports